<template>
  <div>
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" :color="appColor" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!-- OFFICERS -->
    <v-navigation-drawer v-if="
      appRole == 'EmergencyUser' ||
      appRole == 'RRT'
    " v-model="sideNav" fixed temporary width="280px" class="modern-sidebar hidden-md-and-up">
      <!-- Logo area -->
      <div class="sidebar-logo-area">
        <Logo />
      </div>

      <div class="sidebar-divider"></div>

      <!-- Scrollable Menu -->
      <div class="sidebar-scroll">
        <div
          v-for="item in items"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
      </div>
    </v-navigation-drawer>
    <!-- OFFICERS -->
    <v-navigation-drawer v-if="
      appRole == 'SEOC' ||
      appRole == 'DEOC'
    " v-model="sideNav" fixed temporary width="280px" class="modern-sidebar hidden-md-and-up">
      <!-- Logo area -->
      <div class="sidebar-logo-area">
        <Logo />
      </div>

      <div class="sidebar-divider"></div>

      <!-- Scrollable Menu -->
      <div class="sidebar-scroll">
        <div
          v-for="item in seocanddeoc"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
      </div>
    </v-navigation-drawer>
    <!-- RANGE -->
    <v-navigation-drawer v-if="
      appRole == 'range'
    " v-model="sideNav" fixed temporary width="280px" class="modern-sidebar hidden-md-and-up">
      <!-- Logo area -->
      <div class="sidebar-logo-area">
        <Logo />
      </div>

      <!-- Section Toggle -->
      <div class="sidebar-section-toggle">
        <button
          class="section-btn"
          :class="{ active: activeSection === 'hwc' }"
          @click="activeSection = 'hwc'"
        >HWC</button>
        <button
          class="section-btn"
          :class="{ active: activeSection === 'sarpa' }"
          @click="activeSection = 'sarpa'"
        >SARPA</button>
      </div>

      <div class="sidebar-divider"></div>

      <!-- HWC Menu -->
      <div class="sidebar-scroll" v-if="activeSection === 'hwc'">
        <div
          v-for="item in items"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
      </div>

      <!-- SARPA Menu -->
      <div class="sidebar-scroll" v-if="activeSection === 'sarpa'">
        <div
          v-for="item in sarpadashboardofficers"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
      </div>
    </v-navigation-drawer>
    <!-- DIVISION -->
    <v-navigation-drawer v-if="
      appRole == 'division'
    " v-model="sideNav" fixed temporary width="280px" class="modern-sidebar hidden-md-and-up">
      <!-- Logo area -->
      <div class="sidebar-logo-area">
        <Logo />
      </div>

      <!-- Section Toggle -->
      <div class="sidebar-section-toggle">
        <button
          class="section-btn"
          :class="{ active: activeSection === 'hwc' }"
          @click="activeSection = 'hwc'"
        >HWC</button>
        <button
          class="section-btn"
          :class="{ active: activeSection === 'sarpa' }"
          @click="activeSection = 'sarpa'"
        >SARPA</button>
      </div>

      <div class="sidebar-divider"></div>

      <!-- HWC Menu -->
      <div class="sidebar-scroll" v-if="activeSection === 'hwc'">
        <div
          v-for="item in divisionitems"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
      </div>

      <!-- SARPA Menu -->
      <div class="sidebar-scroll" v-if="activeSection === 'sarpa'">
        <div
          v-for="item in sarpadashboardofficers"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
      </div>
    </v-navigation-drawer>
    <!-- CIRCLE -->
    <v-navigation-drawer v-if="appRole == 'circle'" v-model="sideNav" fixed temporary width="280px"
      class="modern-sidebar hidden-md-and-up">
      <!-- Logo area -->
      <div class="sidebar-logo-area">
        <Logo />
      </div>

      <!-- Section Toggle -->
      <div class="sidebar-section-toggle">
        <button
          class="section-btn"
          :class="{ active: activeSection === 'hwc' }"
          @click="activeSection = 'hwc'"
        >HWC</button>
        <button
          class="section-btn"
          :class="{ active: activeSection === 'sarpa' }"
          @click="activeSection = 'sarpa'"
        >SARPA</button>
      </div>

      <div class="sidebar-divider"></div>

      <!-- HWC Menu -->
      <div class="sidebar-scroll" v-if="activeSection === 'hwc'">
        <div
          v-for="item in circleitems"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
      </div>

      <!-- SARPA Menu -->
      <div class="sidebar-scroll" v-if="activeSection === 'sarpa'">
        <div
          v-for="item in sarpadashboardofficers"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
      </div>
    </v-navigation-drawer>
    <!-- ADMIN -->
    <v-navigation-drawer v-if="appRole == 'admin' && $route.name !== 'mapping'" v-model="sideNav" fixed temporary
      width="280px" class="modern-sidebar hidden-md-and-up">
      <!-- Logo area -->
      <div class="sidebar-logo-area">
        <Logo />
      </div>

      <!-- Section Toggle -->
      <div class="sidebar-section-toggle">
        <button
          class="section-btn"
          :class="{ active: activeSection === 'hwc' }"
          @click="activeSection = 'hwc'"
        >HWC</button>
        <button
          class="section-btn"
          :class="{ active: activeSection === 'sarpa' }"
          @click="activeSection = 'sarpa'"
        >SARPA</button>
      </div>

      <div class="sidebar-divider"></div>

      <!-- HWC Menu -->
      <div class="sidebar-scroll" v-if="activeSection === 'hwc'">
        <div
          v-for="item in adminItems"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
        <!-- Dynamic Data group -->
        <v-list-group class="sidebar-group pt-0 mt-0" no-action>
          <template v-slot:activator>
            <div class="sidebar-item group-activator" style="padding-left: 0; padding-right: 0;">
              <v-icon class="sidebar-icon">{{ report.icon }}</v-icon>
              <span class="sidebar-label">{{ report.title }}</span>
            </div>
          </template>
          <div
            v-for="child in report.reportItems"
            :key="child.title"
            class="sidebar-item sidebar-item--child"
            :class="{ 'sidebar-item--active': $route.path === child.path }"
            @click="navigateTo(child.path)"
          >
            <v-icon class="sidebar-icon" style="font-size:14px">mdi-chevron-right</v-icon>
            <span class="sidebar-label">{{ child.title }}</span>
          </div>
        </v-list-group>
      </div>

      <!-- SARPA Menu -->
      <div class="sidebar-scroll" v-if="activeSection === 'sarpa'">
        <div
          v-for="item in sarpadashboard"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
      </div>
    </v-navigation-drawer>
    <!-- SEOC -->
    <v-navigation-drawer v-if="appRole == 'SEOC' && $route.name !== 'mapping'" v-model="sideNav" fixed temporary
      width="280px" class="modern-sidebar hidden-md-and-up">
      <!-- Logo area -->
      <div class="sidebar-logo-area">
        <Logo />
      </div>

      <!-- Section Toggle -->
      <div class="sidebar-section-toggle">
        <button
          class="section-btn"
          :class="{ active: activeSection === 'hwc' }"
          @click="activeSection = 'hwc'"
        >HWC</button>
        <button
          class="section-btn"
          :class="{ active: activeSection === 'sarpa' }"
          @click="activeSection = 'sarpa'"
        >SARPA</button>
      </div>

      <div class="sidebar-divider"></div>

      <!-- HWC Menu -->
      <div class="sidebar-scroll" v-if="activeSection === 'hwc'">
        <div
          v-for="item in SEOCItems"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
        <!-- Dynamic Data group -->
        <v-list-group class="sidebar-group pt-0 mt-0" no-action>
          <template v-slot:activator>
            <div class="sidebar-item group-activator" style="padding-left: 0; padding-right: 0;">
              <v-icon class="sidebar-icon">{{ report.icon }}</v-icon>
              <span class="sidebar-label">{{ report.title }}</span>
            </div>
          </template>
          <div
            v-for="child in report.reportItems"
            :key="child.title"
            class="sidebar-item sidebar-item--child"
            :class="{ 'sidebar-item--active': $route.path === child.path }"
            @click="navigateTo(child.path)"
          >
            <v-icon class="sidebar-icon" style="font-size:14px">mdi-chevron-right</v-icon>
            <span class="sidebar-label">{{ child.title }}</span>
          </div>
        </v-list-group>
      </div>

      <!-- SARPA Menu -->
      <div class="sidebar-scroll" v-if="activeSection === 'sarpa'">
        <div
          v-for="item in SEOCsarpadashboard"
          :key="item.title"
          class="sidebar-item"
          :class="{ 'sidebar-item--active': $route.path === item.path }"
          @click="navigateTo(item.path)"
        >
          <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-label">{{ item.title }}</span>
          <span class="sidebar-active-bar"></span>
        </div>
      </div>
    </v-navigation-drawer>
    <!-- SIDENAV -->
    <v-navigation-drawer v-model="sideNavRight" right fixed temporary width="220px" class="hidden-md-and-up"
      color="#FAFAFA">
      <v-layout wrap>
        <v-flex v-for="(item, i) in headerItems" :key="i" xs12 text-center>
          <v-layout wrap>
            <v-flex xs12 @click="changeRoute(item)" :class="$route.query.id == item.nameValue
              ? 'appHeaderActiveClass'
              : 'appHeaderNormalClass' &&
                !$route.query.id &&
                item.nameValue == 'activeCases'
                ? 'appHeaderActiveClass'
                : 'appHeaderNormalClass'
              " style="
                text-decoration: none;
                cursor: pointer;
                letter-spacing: 0px;
              ">
              <span :class="$vuetify.breakpoint.name == 'md'
                ? 'font-size-md'
                : 'font-size-other'
                ">
                {{ item.title }}:
              </span>
              <v-btn color="#ededed" elevation="0" width="40px" height="35px" fab><span class="pa-1"
                  style="color: #000; font-size: 10px">{{
                    item.value
                  }}</span>
              </v-btn>
            </v-flex>
            <v-flex xs12 pt-3>
              <v-progress-linear height="5px" v-if="
                $route.query.id == item.nameValue ||
                (!$route.query.id && item.nameValue == 'activeCases')
              " value="100" color="#ededed"></v-progress-linear>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>
    <!-- APPHEADER -->

    <v-app-bar color="#FFFFFF" flat class="hidden-md-and-up appTopBar appTopBar--mobile"
      v-if="$route.name !== 'mapping'">
      <v-app-bar-nav-icon @click.native="sideNav = !sideNav">
        <v-icon color="#173824">mdi-menu</v-icon>
      </v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <v-btn icon @click="sideNavRight = !sideNavRight">
        <v-icon color="#5f7d6b" size="21">mdi-tune-variant</v-icon>
      </v-btn>
      <div class="mobileBellSlot">
        <AppNotifications />
      </div>

      <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon color="#000">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-card class="mobile-profile-card" width="280px">
          <v-layout wrap justify-center>
            <v-flex xs12 class="text-center pt-2 pb-1">
              <span class="mobile-welcome-text">Welcome</span>
            </v-flex>
            <v-flex xs12 class="text-center py-2">
              <div class="mobile-avatar-container">
                <span v-if="userInitial" class="mobile-avatar-initial">{{ userInitial }}</span>
                <v-icon v-else color="#2e6b3f" size="26">mdi-account</v-icon>
              </div>
            </v-flex>
            <v-flex xs12 class="text-center px-2" v-if="appLogin && (appUserrole === 'admin' || appUserrole === 'SEOC')">
              <router-link to="/Admin/profile" class="mobile-profile-link">
                <div class="mobile-user-name">{{ appUser }}</div>
                <div class="mobile-user-role">{{ appUserrole }}</div>
              </router-link>
            </v-flex>
            <v-flex xs12 class="text-center px-2" v-if="appLogin && appUserrole !== 'admin' && appUserrole !== 'SEOC'">
              <router-link to="/Officers/profile" class="mobile-profile-link">
                <div class="mobile-user-name">{{ appUser }}</div>
                <div class="mobile-user-role">{{ appUserrole }}</div>
              </router-link>
            </v-flex>
            <v-flex xs12 class="text-center pt-3 px-2">
              <v-divider class="my-2"></v-divider>
              <v-btn
                v-if="!appLogin"
                color="#2e6b3f"
                depressed
                block
                rounded
                class="text-capitalize mobile-action-btn"
                to="/login"
              >
                Login
              </v-btn>
              <v-btn
                v-if="appLogin"
                color="#c0392b"
                text
                block
                rounded
                class="text-capitalize mobile-logout-btn mt-1"
                @click="appLogout"
              >
                <v-icon left size="16">mdi-logout</v-icon>
                Logout
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-app-bar
      color="#FFFFFF"
      flat
      class="hidden-sm-and-down appTopBar"
      height="60px"
      v-if="$route.name !== 'mapping'"
    >
      <div class="appTopBar__inner">
        <!-- Case-count tabs -->
        <nav class="caseTabs">
          <button
            v-for="(item, i) in headerItems"
            :key="i"
            type="button"
            class="caseTab"
            :class="{ 'caseTab--active': isHeaderTabActive(item) }"
            @click="changeRoute(item)"
          >
            <span class="caseTab__label">{{ item.title }}</span>
            <span class="caseTab__count">{{ item.value }}</span>
          </button>
        </nav>

        <div class="appTopBar__actions">
          <AppNotifications />

          <AccountMenu v-if="appLogin" />
        </div>
      </div>
    </v-app-bar>
  </div>
</template>
<script>
//WILDWATCH
import axios from "axios";
import AccountMenu from "./accountMenu";
import AppNotifications from "@/views/Notifications/newappNotify";
import Socket from "./../../Sockets/socket";

export default {
  components: {
    AppNotifications,
    AccountMenu,
  },
  data() {
    return {
      activeSection: 'hwc',
      ServerError: false,
      msg: null,
      showSnackBar: false,
      timeout: 5000,
      searchKey: this.$route.query.searchKey
        ? this.$route.query.searchKey
        : null,
      sideNav: false,
      sideNavRight: false,
      adminItems: [
        {
          title: "Home",
          icon: "mdi-view-dashboard",
          path: "/Admin/admindashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Admin/profile" },
        // { title: "Public", icon: "mdi-account-group", path: "/Admin/public" },
        // {
        //   title: "Conflict Reports",
        //   icon: "mdi-source-repository-multiple",
        //   path: "/Admin/ConflictReports",
        // },
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/admin/analytics",
        },
        {
          title: "Statistics ",
          icon: "mdi-chart-bar",
          path: "/admin/hwcanalyticspage",
        },
        {
          title: "Add Emergency User",
          icon: "mdi-account-plus",
          path: "/Admin/emergencyUser",
        },
        // {
        //   title: "Notifications",
        //   icon: "mdi-bell",
        //   path: "/Admin/notifications",
        // },
        // {
        //   title: "All Reportings",
        //   icon: "mdi-file-chart",
        //   path: "/Admin/myReport",
        // },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/reportGeneration",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Admin/closedcases",
        },
        {
          title: "Map",
          icon: "mdi-map-search-outline",
          path: "/Admin/mapping",
        },
        { title: "Add DEOC", icon: "mdi-account-plus-outline", path: "/Admin/adddeoc" },
        { title: "Add RRT", icon: "mdi-account-plus-outline", path: "/Admin/addrrt" },
        { title: "Add Analyst", icon: "mdi-chart-line", path: "/Admin/addanalyst" },
        {
          title: "Daily Report",
          icon: "mdi-file-pdf-box",
          path: "/Admin/daily-report",
        },
        {
          title: "Daily Rescue Report",
          icon: "mdi-file-pdf-box",
          path: "/Admin/daily-report-rescue",
        },
      ],
      report: {
        title: "Dynamic Data",
        icon: "mdi-folder",
        visible: false,
        reportItems: [
          {
            title: "Scenerios",
            path: "/Admin/dynamicData/scenerios",
          },
          {
            title: "Animals",
            path: "/Admin/dynamicData/animals",
          },
          {
            title: "Animal Activities",
            path: "/Admin/dynamicData/animalActivities",
          },
          {
            title: "Animal Status",
            path: "/Admin/dynamicData/animalStatus",
          },
          {
            title: "Mitigations",
            path: "/Admin/dynamicData/mitigationTypes",
          },
          {
            title: "Land Types",
            path: "/Admin/dynamicData/landTypes",
          },
          {
            title: "Gender",
            path: "/Admin/dynamicData/gender",
          },
          {
            title: "Breach Types",
            path: "/Admin/dynamicData/breachType",
          },
          {
            title: "Barrier Types",
            path: "/Admin/dynamicData/barrierType",
          },
          {
            title: "Conflict Types",
            path: "/Admin/dynamicData/conflictType",
          },
          {
            title: "Crop Types",
            path: "/Admin/dynamicData/cropType",
          },
        ],
      },
      sarpadashboard: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Sarpa/dashboard",
        },
        {
          title: "Add Snakes",
          icon: "mdi-snake",
          path: "/addSnakes",
        },
        {
          title: "All Users",
          icon: "mdi-account-multiple",
          path: "/usersList",
        },
        {
          title: "New Rescuers",
          icon: "mdi-account-plus-outline",
          path: "/newrescuerslist",
        },
        {
          title: "Rescuer List",
          icon: "mdi-format-list-bulleted",
          path: "/allrescuerlist",
        },
        {
          title: "Banned Rescuers",
          icon: "mdi-account-cancel-outline",
          path: "/bannedrescuerlist",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-view-dashboard",
        //   path: "/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-view-dashboard",
        //   path: "/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-view-dashboard",
        //   path: "/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-view-dashboard",
        //   path: "/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-view-dashboard",
        //   path: "/approvedoperations",
        // },
        {
          title: "Delete Operations",
          icon: "mdi-delete-alert-outline",
          path: "/deleteoperations",
        },
        {
          title: "Training List",
          icon: "mdi-school-outline",
          path: "/traininglist",
        },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart-outline",
          path: "/snakereports",
        },
        {
          title: "Add Snake Experts",
          icon: "mdi-account-star-outline",
          path: "/addsnakeexperts",
        },
        {
          title: "Add Hospital",
          icon: "mdi-hospital-box-outline",
          path: "/addhospital",
        },
        {
          title: "View Hospital",
          icon: "mdi-hospital-building",
          path: "/Viewhospital",
        },
        {
          title: "Identification Help",
          icon: "mdi-help-circle-outline",
          path: "/identificationhelp",
        },
        // {
        //   title: "Approve Hospital",
        //   icon: "mdi-view-dashboard",
        //   path: "/approvehospital",
        // },
            {
          title: "Badge Levels",
          icon: "mdi-medal-outline",
          path: "/badgelevels",
        },
        {
          title: "Ratings Operations",
          icon: "mdi-star-outline",
          path: "/ratingsoperations",
        },
        //website contents
        {
          title: "About SARPA Rescuers",
          icon: "mdi-account-group-outline",
          path: "/about-sarpa-rescuers",
        },
        {
          title: "Privacy Policy",
          icon: "mdi-shield-lock-outline",
          path: "/manage-privacy-policy",
        },
        {
          title: "Terms & Conditions",
          icon: "mdi-file-document-outline",
          path: "/terms-and-conditions",
        },
        {
          title: "About Us",
          icon: "mdi-information-outline",
          path: "/about-us",
        },
        {
          title: "Mission & Vision",
          icon: "mdi-eye-outline",
          path: "/mission-and-vision",
        },
        {
          title: "Back Story",
          icon: "mdi-history",
          path: "/back-story",
        }
      ],
      SEOCitems: [
        {
          title: "Statistics ",
          icon: "mdi-chart-bar",
          path: "/admin/hwcanalyticspage",
        },
        {
          title: "Home",
          icon: "mdi-view-dashboard",
          path: "/Admin/admindashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Admin/profile" },
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/admin/analyticspage",
        },
        {
          title: "Add SEOC User",
          icon: "mdi-account-plus",
          path: "/Admin/emergencyUser",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Admin/notifications",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/reportGeneration",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Admin/closedcases",
        },
        {
          title: "Map",
          icon: "mdi-map-search-outline",
          path: "/Admin/mapping",
        },
        { title: "Add DEOC", icon: "mdi-account-plus-outline", path: "/Admin/adddeoc" },
        { title: "Add RRT", icon: "mdi-account-plus-outline", path: "/Admin/addrrt" },
        { title: "Add Analyst", icon: "mdi-chart-line", path: "/Admin/addanalyst" },
      ],
      SEOCsarpadashboard: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Sarpa/dashboard",
        },
        {
          title: "Statistics ",
          icon: "mdi-chart-bar",
          path: "/admin/sarpaanalyticspage",
        },
        {
          title: "Add Snakes",
          icon: "mdi-snake",
          path: "/addSnakes",
        },
        {
          title: "All Users",
          icon: "mdi-account-multiple",
          path: "/usersList",
        },
        {
          title: "New Rescuers",
          icon: "mdi-account-plus-outline",
          path: "/newrescuerslist",
        },
        {
          title: "Rescuer List",
          icon: "mdi-format-list-bulleted",
          path: "/allrescuerlist",
        },
        {
          title: "Banned Rescuers",
          icon: "mdi-account-cancel-outline",
          path: "/bannedrescuerlist",
        },
        {
          title: "Approve All",
          icon: "mdi-check-decagram-outline",
          path: "/approveoperations",
        },
        {
          title: "Pending Operations",
          icon: "mdi-receipt-clock-outline",
          path: "/pendingoperations",
        },
        {
          title: "Assigned Operations",
          icon: "mdi-clipboard-check",
          path: "/assignedoperations",
        },
        {
          title: "Rescued Operations",
          icon: "mdi-invoice-list",
          path: "/rescuedoperations",
        },
        {
          title: "Released Operations",
          icon: "mdi-view-list",
          path: "/releasedoperations",
        },
        {
          title: "Approved Operations",
          icon: "mdi-playlist-check",
          path: "/approvedoperations",
        },
        {
          title: "Delete Operations",
          icon: "mdi-delete-alert-outline",
          path: "/deleteoperations",
        },
        {
          title: "Training List",
          icon: "mdi-school-outline",
          path: "/traininglist",
        },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart-outline",
          path: "/snakereports",
        },
        {
          title: "Add Snake Experts",
          icon: "mdi-account-star-outline",
          path: "/addsnakeexperts",
        },
        {
          title: "Add Hospital",
          icon: "mdi-hospital-box-outline",
          path: "/addhospital",
        },
        {
          title: "View Hospital",
          icon: "mdi-hospital-building",
          path: "/Viewhospital",
        },
        {
          title: "Identification Help",
          icon: "mdi-help-circle-outline",
          path: "/identificationhelp",
        },
        {
          title: "Excel",
          icon: "mdi-file-excel",
          path: "/excelreport",
        },
        // {
        //   title: "Approve Hospital",
        //   icon: "mdi-check-decagram-outline",
        //   path: "/approvehospital",
        // },
      ],
      sarpadashboardofficers: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/officers/sarpadashboard",
        },
        // {
        //   title: "Statistics ",
        //   icon: "mdi-chart-bar",
        //   path: "/admin/commonanalyticspage",
        // },
        // {
        //   title: "Add Snakes",
        //   icon: "mdi-plus",
        //   path: "/addSnakes",
        // },
        // {
        //   title: "All Users",
        //   icon: "mdi-account-multiple",
        //   path: "/usersList",
        // },
        // {
        //   title: "New Rescuers",
        //   icon: "mdi-file-plus",
        //   path: "/newrescuerslist",
        // },
        // {
        //   title: "Rescuer List",
        //   icon: "mdi-format-list-bulleted",
        //   path: "/allrescuerlist",
        // },
        {
          title: "Pending Operations",
          icon: "mdi-receipt-clock-outline",
          path: "/officers/pendingoperations",
        },
        {
          title: "Assigned Operations",
          icon: "mdi-clipboard-check",
          path: "/officers/assignedoperations",
        },
        {
          title: "Rescued Operations",
          icon: "mdi-invoice-list",
          path: "/officers/rescuedoperations",
        },
        {
          title: "Released Operations",
          icon: "mdi-view-list",
          path: "/officers/releasedoperations",
        },
        {
          title: "Approved Operations",
          icon: "mdi-playlist-check",
          path: "/officers/approvedoperations",
        },
        // {
        //   title: "Delete Operations",
        //   icon: "mdi-delete-alert",
        //   path: "/officers/deleteoperations",
        // },
        // {
        //   title: "Training List",
        //   icon: "mdi-chair-school",
        //   path: "/officers/traininglist",
        // },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart-outline",
          path: "/officers/snakereports",
        },
        // {
        //   title: "Add Snake Experts",
        //   icon: "mdi-plus",
        //   path: "/addsnakeexperts",
        // },
        // {
        //   title: "Add Hospital",
        //   icon: "mdi-hospital-building",
        //   path: "/addhospital",
        // },
        {
          title: "View Hospital",
          icon: "mdi-hospital-building",
          path: "/officers/Viewhospital",
        },
        {
          title: "Identification Help",
          icon: "mdi-help-circle-outline",
          path: "/officers/identificationhelp",
        },
        {
          title: "Excel",
          icon: "mdi-file-excel",
          path: "/officers/excelreport",
        },
        // {
        //   title: "Approve Hospital",
        //   icon: "mdi-check-decagram-outline",
        //   path: "/approvehospital",
        // },
      ],
      dynamic: [
        {
          title: "Dynamic Data",
          icon: "mdi-folder",
          visible: false,
          items: [
            {
              title: "Scenerios",
              path: "/Admin/dynamicData/scenerios",
            },
            {
              title: "Animals",
              path: "/Admin/dynamicData/animals",
            },
            {
              title: "Animal Activities",
              path: "/Admin/dynamicData/animalActivities",
            },
            {
              title: "Animal Status",
              path: "/Admin/dynamicData/animalStatus",
            },
            // {
            //   title: "Animal Age",
            //   path: "/Admin/dynamicData/animalAge",
            // },
            // {
            //   title: "Veterinary Recommendation",
            //   path: "/Admin/dynamicData/veterinaryRecommendation",
            // },
            {
              title: "Mitigations",
              path: "/Admin/dynamicData/mitigationTypes",
            },
            {
              title: "Land Types",
              path: "/Admin/dynamicData/landTypes",
            },
            {
              title: "Gender",
              path: "/Admin/dynamicData/gender",
            },
            // {
            //   title: "Close Status",
            //   path: "/Admin/dynamicData/closeStatus",
            // },
            // {
            //   title: "Release Types",
            //   path: "/Admin/dynamicData/releaseTypes",
            // },
            {
              title: "Breach Types",
              path: "/Admin/dynamicData/breachType",
            },
            {
              title: "Barrier Types",
              path: "/Admin/dynamicData/barrierType",
            },
            {
              title: "Conflict Types",
              path: "/Admin/dynamicData/conflictType",
            },
            {
              title: "Crop Types",
              path: "/Admin/dynamicData/cropType",
            },
          ],
        },
      ],
      sarpa: {
        title: "SARPA",
        icon: "mdi-snake",
        visible: false,
        sarpaItems: [
          {
            title: "Dashboard",
            path: "/Sarpa/dashboard",
          },
          {
            title: "Add Snakes",
            path: "/addSnakes",
          },
          {
            title: "All Users",
            path: "/usersList",
          },
          {
            title: "New Rescuers",
            path: "/newrescuerslist",
          },
          {
            title: "Rescuer List",
            path: "/allrescuerlist",
          },
          {
            title: "Pending Operations",
            path: "/pendingoperations",
          },
          {
            title: "Assigned Operations",
            path: "/assignedoperations",
          },
          {
            title: "Rescued Operations",
            path: "/rescuedoperations",
          },
          {
            title: "Released Operations",
            path: "/releasedoperations",
          },
          {
            title: "Approved Operations",
            path: "/approvedoperations",
          },
          {
            title: "Delete Operations",
            path: "/deleteoperations",
          },
          {
            title: "Training List",
            path: "/traininglist",
          },
          {
            title: "Snake Reports",
            path: "/snakereports",
          },
          {
            title: "Add Snake Experts",
            path: "/addsnakeexperts",
          },
          {
            title: "Add Hospital",
            path: "/addhospital",
          },
          {
            title: "View Hospital",
            path: "/Viewhospital",
          },
          {
            title: "Identification Help",
            path: "/identificationhelp",
          },
          {
            title: "Approve Hospital",
            path: "/approvehospital",
          },
        ],
      },
      // items: [
      //   {
      //     title: "Dashboard",
      //     icon: "mdi-view-dashboard",
      //     path: "/Officers/dashboard",
      //   },
      //   {
      //     title: "My Details",
      //     icon: "mdi-account",
      //     path: "/Officers/myDetails",
      //   },
      //   { title: "Teams", icon: "mdi-account-group", path: "/Officers/teams" },
      //   { title: "Forms", icon: "mdi-form-select", path: "/Officers/forms" },
      //   {
      //     title: "Notifications",
      //     icon: "mdi-bell",
      //     path: "/Officers/notifications",
      //   },
      //   {
      //     title: "Officers",
      //     icon: "mdi-account-circle",
      //     path: "/Officers/officers",
      //   },
      //   {
      //     title: "Merge Cases",
      //     icon: "mdi-call-merge",
      //     path: "/Officers/mergeCases",
      //   },
      //   {
      //     title: "Analytics",
      //     icon: "mdi-home-analytics",
      //     path: "/Officers/analytics",
      //   },
      // ],
      items: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Officers/dashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Officers/profile" },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/Officers/analytics",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/Officers/reportGenerationofficers",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Officers/notifications",
        },
        {
          title: "Report Case",
          icon: "mdi-file-eye",
          path: "/Officers/reportcase",
        },
        // {
        //   title: "Merge Cases",
        //   icon: "mdi-call-merge",
        //   path: "/Officers/mergeCases",
        // },
      ],
      SEOCItems: [
        {
          title: "Statistics ",
          icon: "mdi-chart-bar",
          path: "/admin/hwcanalyticspage",
        },
        {
          title: "Home",
          icon: "mdi-view-dashboard",
          path: "/Admin/admindashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Admin/profile" },
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/admin/analyticspage",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Admin/notifications",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/reportGeneration",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Admin/closedcases",
        },
        {
          title: "Map",
          icon: "mdi-map-search-outline",
          path: "/Admin/mapping",
        },
        {
          title: "Daily Report",
          icon: "mdi-file-pdf-box",
          path: "/Admin/daily-report",
        },
        {
          title: "Daily Rescue Report",
          icon: "mdi-file-pdf-box",
          path: "/Admin/daily-report-rescue",
        },

      ],
      seocanddeoc: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Officers/dashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Officers/profile" },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/Officers/analytics",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/Officers/reportGenerationofficers",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Officers/notifications",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Officers/closedcases",
        },
        {
          title: "Report Case",
          icon: "mdi-file-eye",
          path: "/Officers/reportcase",
        },
        {
          title: "Daily Reporting",
          icon: "mdi-chart-tree",
          path: "/Officers/daily-reporting",
        },
        {
          title: "Daily Report",
          icon: "mdi-file-pdf-box",
          path: "/Officers/daily-report",
        },
        {
          title: "Daily Rescue Reporting",
          icon: "mdi-chart-tree",
          path: "/Officers/daily-reporting-rescue",
        },
        {
          title: "Daily Rescue Report",
          icon: "mdi-file-pdf-box",
          path: "/Officers/daily-report-rescue",
        },
      ],
      divisionitems: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Officers/dashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Officers/profile" },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/Officers/analytics",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/Officers/reportGenerationofficers",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Officers/notifications",
        },
        {
          title: "Report Case",
          icon: "mdi-file-eye",
          path: "/Officers/reportcase",
        },
        {
          title: "DEOC USER",
          icon: "mdi-account-outline",
          path: "/Officers/adddeoc",
        },
        // {
        //   title: "SEOC USER",
        //   icon: "mdi-account",
        //   path: "/Officers/addSeoc",
        // },
        // {
        //   title: "Merge Cases",
        //   icon: "mdi-call-merge",
        //   path: "/Officers/mergeCases",
        // },
      ],
      circleitems: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Officers/dashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Officers/profile" },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/Officers/analytics",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/Officers/reportGenerationofficers",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Officers/notifications",
        },
        // {
        //   title: "Report Case",
        //   icon: "mdi-file-eye",
        //   path: "/Officers/reportcase",
        // },
      ],
      headerItems: [
        {
          title: "Active Cases",
          value: 0,
          path: "/?id=activeCases",
          nameValue: "activeCases",
        },

        {
          title: "Assigned Cases",
          value: 0,
          path: "/?id=assignedCases",
          nameValue: "assignedCases",
        },
        {
          title: "Resolved Cases",
          value: 0,
          path: "/?id=resolvedCases",
          nameValue: "resolvedCases",
        },
        {
          title: "Released Cases",
          value: 0,
          path: "/?id=releasedCases",
          nameValue: "releasedCases",
        },
      ],
      analytics: {},
      mergeValue: null,

      // socket Variables
      // role: null,
      socketType: null,
      newData: {},
      activeCasesvalue: "",
      assignedCasesvalue: "",
      resolvedCasesvalue: "",
    };
  },
  beforeMount() {
    if (this.searchKey) this.appSearch();
    else this.getData();
  },
  mounted() {
    // this.socketData();
    if (this.appRole == "admin") {
      // console.log("first", this.newData);
      this.assignAnalytics(this.newData);
    }
    // this.getSearch()
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appUser() {
      return this.$store.state.userName;
    },
    appUserrole() {
      return this.$store.state.userRole;
    },
    userInitial() {
      const name = this.$store.state.userName;
      return name ? String(name).trim().charAt(0) : "";
    },
    appRole() {
      return this.$store.state.userRole;
    },
    counterData() {
      return this.$store.state.counterData;
    },
    appNotification() {
      if (this.$store.state.notification == undefined) {
        return 0;
      } else {
        return this.$store.state.notification;
      }
    },
  },
  watch: {
    counterData: {
      handler: function () {
        // console.log(this.storage);
        this.assignAnalytics(this.counterData);
      },
      deep: true,
    },
    // searchKey() {
    //   this.assignAnalytics(this.counterData);
    // },
    // role() {
    //   if (this.role == "official") {
    //     this.assignAnalytics(this.newData)
    //   }
    // },
    //  socketType() {
    //   if (this.socketType == "resolveReport"|| this.socketType == "reportRelease") {
    //     this.assignAnalytics(this.newData)
    //   }
    // },
  },
  // sockets: {
  //   connect() {
  //     // Fired when the socket connects.
  //     this.isConnected = true;
  //   },

  //   disconnect() {
  //     this.isConnected = false;
  //   },

  //   // Fired when the server sends something on the "messageChannel" channel.
  //   messageChannel(data) {
  //     this.socketMessage = data;
  //   },
  // },
  methods: {
    appLogout() {
      this.$store.commit("logoutUser", true);
    },
    navigateTo(path) {
      this.$router.push(path).catch(() => {});
      this.sideNav = false;
    },
    resetMap() {
      this.searchKey = "";
      this.$route.query.searchKey = null;
      // window.location.reload();
    },
    // loadData() {
    //   var newData = {};
    //   newData = this.counterData;
    //   console.log(newData, "newData");
    //   this.assignAnalytics(newData);
    // },

    assignAnalytics(analytics) {
      if (analytics.activeCases > 0) {
        this.headerItems[0].value = analytics.activeCases;
      }
      else {
        this.headerItems[0].value = 0;
      }
      if (analytics.assignedCases > 0) {
        this.headerItems[1].value = analytics.assignedCases;
      }
      else {
        this.headerItems[1].value = 0;
      }
      if (analytics.resolvedCases > 0) {
        this.headerItems[2].value = analytics.resolvedCases;
      }
      else {
        this.headerItems[2].value = 0;
      }
      if (analytics.releasedCases > 0) {
        this.headerItems[3].value = analytics.releasedCases;
      }
      else {
        this.headerItems[3].value = 0;
      }
    },
    socketData() {
      Socket.countFunction(this); // <---read data
    },
    //WILDWATCH
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/dashboard",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.analytics = response.data.count;
            this.$store.commit("counterData", response.data.count);
            this.assignAnalytics(this.analytics);
            this.$store.commit(
              "changeNotification",
              response.data.unreadNotification
            );
            this.mergeValue = this.analytics.mergeSuggestion;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;

          this.appLoading = false;
          console.log(err);
        });
    },
    getDatasearchKey() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/dashboard",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          searchKey: this.searchKey
        }

      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.analytics = response.data.count;
            this.$store.commit("counterData", response.data.count);
            this.assignAnalytics(this.analytics);
            this.$store.commit(
              "changeNotification",
              response.data.unreadNotification
            );
            this.mergeValue = this.analytics.mergeSuggestion;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;

          this.appLoading = false;
          console.log(err);
        });
    },
    // "Active Cases" is the implicit default when no ?id is present, but only on
    // the dashboards that actually render the case list. On Statistics,
    // Analytics and every other route no tab should look selected.
    isHeaderTabActive(item) {
      const current = this.$route.query.id;
      if (current) return current === item.nameValue;
      const listPaths = ["/admin/admindashboard", "/officers/dashboard"];
      const path = String(this.$route.path || "").toLowerCase();
      return item.nameValue === "activeCases" && listPaths.indexOf(path) !== -1;
    },
    changeRoute(item) {
      if (this.$store.state.userRole == "admin" || this.$store.state.userRole == "SEOC") {
        this.$router.push({
          path: "/admin/adminDashboard",
          query: {
            id: this.$route.query.id != item.nameValue ? item.nameValue : null,
            searchKey: this.$route.query.searchKey,
          },
        });
      } else if (
        this.$store.state.userRole == "official" ||
        this.$store.state.userRole == "DEOC" ||
        this.$store.state.userRole == "SEOC" ||
        this.$store.state.userRole == "range" ||
        this.$store.state.userRole == "division" ||
        this.$store.state.userRole == "EmergencyUser" ||
        this.$store.state.userRole == "RRT" ||
        this.$store.state.userRole == "circle"
      ) {
        this.$router.push({
          path: "/officers/dashboard",
          query: {
            id: this.$route.query.id != item.nameValue ? item.nameValue : null,
            searchKey: this.$route.query.searchKey,
          },
        });
      }
    },
    appSearch() {
      if (this.$route.query.searchKey == this.searchKey) return;
      this.$router.push({
        path: "",
        query: {
          id: this.$route.query.id,
          searchKey: this.searchKey,
        },
      });
      this.getDatasearchKey();
    },
  },
};
</script>

<style>
/* ---------- Sticky behaviour ----------
   The bar sat in normal flow and scrolled away with the case list. */
.appTopBar {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 0;
  z-index: 7;
}

/* Notification bell + account pill share one visual language. */
.appTopBar__actions .v-btn--icon,
.mobileBellSlot .v-btn--icon {
  border-radius: 999px;
}
.appTopBar__actions .v-badge__badge {
  font-family: sofiaProSemiBold;
  font-size: 9px;
  min-width: 16px;
  height: 16px;
}
.bellWrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  border: 1px solid #dfe6e1;
  background: #f7faf8;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.bellWrap:hover {
  background: #eef4f0;
  border-color: #b9cbbf;
}

/* ---------- Mobile top bar ---------- */
.appTopBar--mobile .v-toolbar__content {
  padding: 0 8px !important;
  gap: 4px;
}
.topSearch--mobile {
  flex: 1 1 auto;
  min-width: 0;
  width: auto;
}
.mobileBellSlot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
}
.mobile-avatar-initial {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 19px;
  font-weight: 600;
  color: #1f5b33;
  line-height: 1;
  text-transform: uppercase;
}

/* ---------- Desktop top bar ---------- */
.appTopBar {
  border-bottom: 1px solid #ecefed;
}
/* The global .v-toolbar__content padding would float the active underline off
   the bar's bottom edge, so cancel it for this bar only. */
.appTopBar .v-toolbar__content {
  padding: 0 24px !important;
  height: 60px !important;
}
.appTopBar__inner {
  display: flex;
  align-items: stretch;
  gap: 24px;
  width: 100%;
  height: 100%;
}

.caseTabs {
  display: flex;
  align-items: stretch;
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
}
.caseTabs::-webkit-scrollbar {
  display: none;
}
.caseTab {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  background: transparent;
  border: 0;
  outline: none;
  cursor: pointer;
  white-space: nowrap;
  font-family: sofiaProRegular;
  font-size: 14px;
  color: #838383;
  transition: color 0.15s ease;
}
.caseTab:hover {
  color: #173824;
}
.caseTab__count {
  min-width: 30px;
  height: 24px;
  padding: 0 9px;
  border-radius: 999px;
  background: #e4efe7;
  color: #2e6b3f;
  border: 1px solid #d3e4d8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: sofiaProSemiBold;
  font-size: 12px;
  transition: background 0.15s ease, color 0.15s ease;
}
.caseTab--active {
  color: #173824;
  font-family: sofiaProSemiBold;
}
.caseTab--active .caseTab__count {
  background: #2e6b3f;
  color: #ffffff;
  border-color: #2e6b3f;
}
.caseTab:hover .caseTab__count {
  border-color: #b9cbbf;
}
/* Visible brand underline - the old indicator was a #ededed progress bar on
   white, which was invisible. */
.caseTab--active::after {
  content: "";
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 0;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: #2e6b3f;
}

.appTopBar__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}
.topSearch {
  width: 240px;
}
.topSearch__field .v-input__slot {
  border-radius: 999px !important;
  min-height: 38px !important;
  background: #f8faf9;
}
.topSearch__field input {
  font-family: sofiaProMedium;
  font-size: 13px;
}
.topSearch__field fieldset {
  border-color: #dfe6e1 !important;
}
.topSearch__field.v-input--is-focused fieldset {
  border-color: #2e6b3f !important;
}

@media (max-width: 1263px) {
  .caseTab {
    padding: 0 10px;
    font-size: 12.5px;
  }
  .topSearch {
    width: 180px;
  }
}

.appHeaderActiveClass {
  font-family: sofiaProSemiBold;
  color: #000 !important;
}

.appHeaderNormalClass {
  font-family: sofiaProRegular;
  color: #838383 !important;
}

.v-toolbar__content,
.v-toolbar__extension {
  padding: 4px 0px !important;
}

.font-size-md {
  font-size: 12px;
}

.font-size-other {
  font-size: 16px;
}

/* Mobile Profile Menu styles */
.mobile-profile-card {
  border-radius: 12px !important;
  border: 1px solid #f1f5f9 !important;
  box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.08), 0 6px 8px -6px rgba(0, 0, 0, 0.03) !important;
  background: #ffffff !important;
  padding: 16px !important;
}

.mobile-welcome-text {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.mobile-avatar-container {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e6f0e8 0%, #cfe3d5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.mobile-profile-link {
  text-decoration: none !important;
  display: block;
}

.mobile-user-name {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 4px;
}

.mobile-user-role {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #1f5b33;
  text-transform: uppercase;
  background-color: #e4efe7;
  display: inline-block;
  padding: 1px 6px;
  border-radius: 9999px;
  margin-top: 2px;
}

.mobile-action-btn {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #ffffff !important;
  box-shadow: 0 4px 6px -1px rgba(46, 107, 63, 0.15) !important;
}

.mobile-logout-btn {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #b3261e !important;
  border: 1px solid #f0dcd9 !important;
  background-color: #fbf3f2 !important;
}

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

/* ── Sidebar shell ─────────────────────────────── */
.modern-sidebar {
  background: linear-gradient(180deg, #183824 0%, #254b31 100%) !important;
  box-shadow: 4px 0 24px rgba(24, 56, 36, 0.15) !important;
  border-right: none !important;
  font-family: 'Inter', sans-serif;
  display: flex !important;
  flex-direction: column !important;
}

/* ── Logo area (fixed header, matches navbar height) */
.sidebar-logo-area {
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  min-height: 60px;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.sidebar-logo-area .v-image {
  max-height: 42px !important;
  max-width: 160px !important;
  margin: 0 auto !important;
}

/* ── Section toggle ────────────────────────────── */
.sidebar-section-toggle {
  display: flex;
  gap: 8px;
  padding: 14px 12px 10px;
}

.section-btn {
  flex: 1;
  padding: 7px 0;
  border: 1.5px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  background: transparent;
  color: rgba(255, 255, 255, 0.55);
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.2px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-transform: uppercase;
}

.section-btn:hover {
  background: rgba(126, 185, 95, 0.15) !important;
  border-color: rgba(126, 185, 95, 0.5) !important;
  color: #7eb95f !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(126, 185, 95, 0.2) !important;
}

.section-btn.active {
  background: linear-gradient(135deg, #7eb95f 0%, #5d9e3b 100%) !important;
  border-color: #7eb95f !important;
  color: #102411 !important;
  box-shadow: 0 4px 16px rgba(126, 185, 95, 0.45) !important;
}

/* ── Divider ───────────────────────────────────── */
.sidebar-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
  margin: 4px 12px 8px;
}

/* ── Scrollable nav area ───────────────────────── */
.sidebar-scroll {
  overflow-y: auto;
  /* 60px logo + 14px top-pad + 44px buttons + 10px bot-pad + 1px divider + margins ≈ 176px */
  height: calc(100vh - 176px);
  flex: 1;
  padding: 4px 8px 16px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.sidebar-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

/* ── Nav items ─────────────────────────────────── */
.sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  margin: 2px 0;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-item::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0);
  transition: background 0.22s ease;
}

.sidebar-item:hover::before {
  background: rgba(255, 255, 255, 0.07);
}

/* No horizontal nudge - it made the whole list feel jittery on hover. */
.sidebar-item:hover::before {
  background: rgba(255, 255, 255, 0.09);
}

.sidebar-item:hover .sidebar-icon {
  color: #7eb95f !important;
  text-shadow: 0 0 10px rgba(126, 185, 95, 0.6) !important;
}

.sidebar-item:hover .sidebar-label {
  color: #ffffff;
}

/* Active state */
/* Softer active state: a translucent green wash with a bright left marker,
   instead of a solid lime block with near-black text. */
.sidebar-item--active {
  background: rgba(126, 185, 95, 0.16) !important;
  border: 1px solid rgba(126, 185, 95, 0.28) !important;
  box-shadow: none !important;
}

.sidebar-item--active .sidebar-icon {
  color: #9ede76 !important;
}

.sidebar-item--active .sidebar-label {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* Marker on the LEFT, where the eye scans for it. */
.sidebar-item--active .sidebar-active-bar {
  display: block !important;
  position: absolute !important;
  left: 0 !important;
  top: 18% !important;
  width: 3px !important;
  height: 64% !important;
  background: #9ede76 !important;
  border-radius: 0 4px 4px 0 !important;
  box-shadow: 0 0 10px rgba(158, 222, 118, 0.55) !important;
}

.sidebar-active-bar {
  display: none;
}

/* Icon & label ────────────────────────────────── */
.sidebar-icon {
  color: rgba(255, 255, 255, 0.45) !important;
  font-size: 18px !important;
  flex-shrink: 0;
  transition: color 0.2s ease, text-shadow 0.2s ease;
}

.sidebar-label {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.65);
  letter-spacing: 0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s ease;
}

/* Child items (nested) ────────────────────────── */
.sidebar-item--child {
  padding-left: 22px;
}

.sidebar-item--child .sidebar-label {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.5);
}

/* Vuetify list-group override inside sidebar ──── */
.sidebar-group .v-list-group__header {
  padding: 0 !important;
  min-height: unset !important;
  background: transparent !important;
}

.sidebar-group .v-list-group__items {
  background: transparent !important;
}

.group-activator {
  width: 100%;
}
</style>
